import { FormControl, makeStyles, TextField } from '@material-ui/core'
import { Stack } from '@mui/material';
import { DateTimePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import React from 'react'
import { useEffect } from 'react';
import { dateTimePickerStyle } from './style';

const DateTimeField = ({
    label,
    value,
    onChange,
    format = "YYYY/MM/DD HH:mm:ss",
    minDate = null,
    maxDate = null,
    required = false
}) => {
    const classes = dateTimePickerStyle();
    const [dateValue, setDateValue] = React.useState(value)

    useEffect(() => {
        if (value === '' || value === null) {
            setDateValue(null);
        }
        setDateValue(value)
    }, [value]);

    return (
        <div className={classes.picker}>
            <LocalizationProvider dateAdapter={AdapterDateFns} >
                <Stack spacing={3}>
                    <DateTimePicker
                        label={label}
                        value={dateValue}
                        onChange={onChange}
                        format={format}
                        minDate={minDate}
                        maxDate={maxDate}
                        renderInput={(params) =>
                            <TextField {...params}
                                variant='outlined'
                                required={required}
                                sx={{ svg: { color: '#0090FE' } }}
                            />}
                    />
                </Stack>
            </LocalizationProvider>
        </div>
    )
}

export default DateTimeField
